export default __webpack_public_path__ + "static/media/client4.40ac87eb.webp";